import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Box } from '@/components/blocks/Box';
import { Flex } from '@/components/blocks/Flex';
import { Link } from '@/components/blocks/Link';
import { Text } from '@/components/blocks/Text';
import { theme } from '@/styles/theme';

const Root = styled(Box)(() =>
  css({
    width: '100%',
    textAlign: 'center',
    paddingTop: theme.spaces.l,
    paddingBottom: theme.spaces.l,
    gap: theme.spaces.m,
    backgroundColor: theme.colors.background.weak,
  })
);

export const Footer = () => {
  const termsUrl = 'https://melmo-app.com/terms';
  const privacyPolicyUrl =
    'https://www.medley.jp/medical-platform/privacy.html';

  return (
    <Root>
      <Flex justifyContent='center' alignItems='center' gap={theme.spaces.m}>
        <Link href={termsUrl}>
          <Text use='xs-N' color='descriptive'>
            利用規約
          </Text>
        </Link>
        <Link href={privacyPolicyUrl}>
          <Text use='xs-N' color='descriptive'>
            プライバシーポリシー
          </Text>
        </Link>
      </Flex>
      <Text use='xs-N' marginTop={theme.spaces.m}>
        &copy;2025 MEDLEY, INC.
      </Text>
    </Root>
  );
};
